import styles from './grow.module.scss';
import MaterialGrow from '@mui/material/Grow';

/* eslint-disable-next-line */
export interface GrowProps {
  children: any,
  // addEndListener?: any,
  // appear?: boolean,
  // easing?: { enter?: string, exit?: string } | string
  in?: boolean,
  // timeout?: 'auto' | number | { appear?: number, enter?: number, exit?: number },
}

export function Grow(props: GrowProps) {
  return (
    <MaterialGrow
      in={props.in}>
      {props.children}
    </MaterialGrow>
  );
}

export default Grow;